import { connect } from 'react-redux';
import { preload } from 'react-isomorphic-render';
import _ from 'lodash';
import GlowforgeProductsPage from 'app/components/product/glowforge-products-page';
import { fetchGlowforgeProductsPage } from 'app/api/product-api';
import { getReferralInfo } from 'app/common/selectors/common';
import features from 'app/common/containers/features';
import { fetchProducts } from 'app/store/api/glowforge-store-api';
import { fetchReferral } from 'app/common/api/common-api';
import clientPreload from 'app/common/containers/client-preload';

const productFromLocation = location => _.split(location.pathname, '/')[2];

const mapStateToProps = (state, props) => ({
  page: { ..._.get(state, 'product.glowforgeProductsPage') },
  products: _.get(state, 'glowforgeStore.products'),
  referralInfo: getReferralInfo(state),
  productId: productFromLocation(props.location),
});

const mapDispatchToProps = dispatch => ({
  // clientPreload HOC expects `clientPreloads` prop as array of promises
  clientPreloads: [
    () => dispatch(fetchReferral()),
  ],
});

const GlowforgeProductsPageContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch, location }) => Promise.all([
    dispatch(fetchGlowforgeProductsPage(productFromLocation(location))),
    dispatch(fetchProducts()),
  ]))(clientPreload(GlowforgeProductsPage)),
);

export default features(GlowforgeProductsPageContainer);



// WEBPACK FOOTER //
// ./app/containers/product/glowforge-products.js